import { jsx } from "react/jsx-runtime";
import { Text } from "recharts";
import { axisTypography, axisTypographyOld } from "./StackBarChart.css.mjs";
const StackBarChartTick = ({
  axisProps,
  isNVLEnabled
}) => /* @__PURE__ */ jsx(
  Text,
  {
    ...axisProps,
    className: isNVLEnabled ? axisTypography : axisTypographyOld,
    width: 100,
    maxLines: 1,
    children: axisProps.tickFormatter ? axisProps.tickFormatter(axisProps.payload.value) : axisProps.payload.value
  }
);
export {
  StackBarChartTick
};
